<template>
  <div>
    <h1 class="title-page">
      <v-icon class="material-icons-outlined">import_contacts</v-icon>
      <br />連絡帳を製本
    </h1>

    <v-card class="card">
      <Overview
        @show-product-detail-full-screen-dialog="
          $emit('show-product-detail-full-screen-dialog')
        "
      />
      <section>
        <p class="sub-text">
          申し訳ありません。<br />
          ご指定の施設では、連絡帳製本をお取り扱いしておりません。
        </p>

        <v-layout justify-center column pb-4 align-center>
          <v-btn
            class="v-btn--minwidth"
            color="negative"
            @click="goToOrganizationTop"
          >
            園トップページへ
          </v-btn>
          <router-link :to="{ name: 'organizations' }" class="mt-3">
            園・施設の切り替え ≫
          </router-link>
        </v-layout>
      </section>
    </v-card>
  </div>
</template>

<script>
import Overview from "../Overview.vue";

export default {
  name: "Unsupported",
  components: {
    Overview
  },
  props: {
    organizationId: {
      type: Number,
      required: true
    }
  },
  methods: {
    goToOrganizationTop() {
      this.$router.push({
        name: "organizationTop",
        params: { organizationId: this.organizationId }
      });
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 443px;
}
.card section {
  padding: 16px;
}
.title-bar {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sub-text {
  font-size: 12px;
  color: #545454;
}
</style>
